import{itemGridColumn as e,itemGridSpacer as t}from"../../sections/section-item-grid/css-classes.js";import{get as n}from"lodash";function r({css:e}){return i({css:e})}function i({css:r}){let i=Math.min(parseInt(n(r,`so-global-region-mix-separator.marginBottom`)||`20px`,10),20);return`
  .${e} > table > tbody > tr > td {
    padding: 0!important;
  }

  .${e} {
    padding-bottom: ${i}px!important;
    padding-top: ${i}px!important;
  }

  .${t} div {
    height: ${i}px!important;
  }
  `}export{i as getItemGridColumnPaddingsForSmallScreenCss,r as getItemGridSmallScreenCss};
//# sourceMappingURL=get-item-grid-section-style.js.map